export default __webpack_public_path__ + "static/media/Contents.3f4fa18d.JPG";